import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withKeys as _withKeys, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4950f5de"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "login-container"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "bg-banner"
}, null, -1));
const _hoisted_3 = {
  id: "login-box"
};
const _hoisted_4 = {
  class: "login-banner"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title-container"
}, [/*#__PURE__*/_createElementVNode("h3", {
  class: "title"
}, "欢迎来到艾登特管理系统 ! 👋🏻")], -1));
const _hoisted_7 = {
  class: "flex-bar"
};
import { ref, watch } from 'vue';
import { ElMessage } from 'element-plus';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { User, Lock } from '@element-plus/icons-vue';
export default {
  __name: 'index',
  setup(__props) {
    const router = useRouter();
    const store = useStore();

    // 表单类型，login 登录，reset 重置密码
    const loading = ref(false);

    // 登录
    const loginFormRef = ref(null);
    const {
      username,
      password,
      remember
    } = JSON.parse(localStorage.getItem('user')) || {};
    const loginForm = ref({
      username: username || '',
      password: password || '',
      remember: remember || false
    });
    const loginRules = ref({
      username: [{
        required: true,
        trigger: 'blur',
        message: '请输入用户名'
      }],
      password: [{
        required: true,
        trigger: 'blur',
        message: '请输入密码'
      }, {
        min: 6,
        max: 18,
        trigger: 'blur',
        message: '密码长度为6到18位'
      }]
    });
    watch(loginForm, val => {
      if (val !== null && val !== void 0 && val.remember) {
        localStorage.setItem('user', JSON.stringify(val));
      } else {
        localStorage.removeItem('user', JSON.stringify(val));
      }
    }, {
      immediate: true,
      deep: true
    });
    const route = useRoute();
    console.log(route);
    const handleLogin = () => {
      loginFormRef.value.validate(valid => {
        if (!valid) return;
        loading.value = true;
        store.dispatch('user/login', loginForm.value).then(() => {
          // 登录后操作
          if (route.query.redirectUrl) {
            router.push(route.query.redirectUrl);
          } else {
            router.push('/');
          }
          loading.value = false;
          ElMessage({
            type: 'success',
            message: '登录成功'
          });
        }).catch(err => {
          console.log(err);
          loading.value = false;
        });
      });
    };
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_checkbox = _resolveComponent("el-checkbox");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("img", {
        src: require('../../assets/login-banner.png'),
        class: "banner"
      }, null, 8, _hoisted_5)]), _createVNode(_component_el_form, {
        ref_key: "loginFormRef",
        ref: loginFormRef,
        model: loginForm.value,
        rules: loginRules.value,
        class: "login-form",
        autocomplete: "on"
      }, {
        default: _withCtx(() => [_hoisted_6, _createElementVNode("div", null, [_createVNode(_component_el_form_item, {
          prop: "username"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: loginForm.value.username,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => loginForm.value.username = $event),
            placeholder: "用户名",
            text: "",
            tabindex: "1",
            autocomplete: "on"
          }, {
            prefix: _withCtx(() => [_createVNode(_component_el_icon, null, {
              default: _withCtx(() => [_createVNode(_unref(User))]),
              _: 1
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          prop: "password"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: loginForm.value.password,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => loginForm.value.password = $event),
            type: "password",
            placeholder: "密码",
            tabindex: "2",
            autocomplete: "on",
            "show-password": "",
            onKeyup: _withKeys(handleLogin, ["enter"])
          }, {
            prefix: _withCtx(() => [_createVNode(_component_el_icon, null, {
              default: _withCtx(() => [_createVNode(_unref(Lock))]),
              _: 1
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        })]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_checkbox, {
          modelValue: loginForm.value.remember,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => loginForm.value.remember = $event)
        }, {
          default: _withCtx(() => [_createTextVNode(" 记住我 ")]),
          _: 1
        }, 8, ["modelValue"])]), _createVNode(_component_el_button, {
          loading: loading.value,
          type: "primary",
          style: {
            "width": "100%"
          },
          onClick: _withModifiers(handleLogin, ["prevent"])
        }, {
          default: _withCtx(() => [_createTextVNode(" 登录 ")]),
          _: 1
        }, 8, ["loading"])]),
        _: 1
      }, 8, ["model", "rules"])])]);
    };
  }
};